<template>
  <card>
    <div slot="header">
      <h4 class="title">Affiliate Companies Setup</h4>
    </div>
    <div class="mb-2">
      <a class="btn-link small" href="#" @click="addCompany()">
        <i class="fa fa-plus"></i> Add Company
      </a>
    </div>
    <div>
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item v-for="company in companies" :title="company.profile.companyName" :name="company.profile.companyName" :key="company.id">
          <div class="row mt-1">
            <div class="col-12 text-right">
              <a class="btn-link smaller" href="#" @click="editCompany(company)">
                <i class="fa fa-edit"></i> Edit Company
              </a>
              <a class="btn-link smaller red ml-2 mr-2" href="#" @click="archiveCompany(company)">
                <i class="fa fa-remove"></i> Archive Company
              </a>
            </div>
          </div>
          <div>
            <Affiliates-Table :forCompany="company" hideCompany hideLeads hideCloseRate/>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </card>
</template>

<script>
import {AffiliateCompanyProxy, Person} from 'src/classes/datamodel.js'
export default {
  name: 'Affiliate-Companies-Setup',
  data () {
    return {
    }
  },
  computed: {
    activeNames: {
      get () {
        return this.companies.length == 1 ? this.companies[0].name : '' 
      },
      set(name) {}
    },
    companies () {
      //  console.log('companies(): ', this.$store.getters.companies)
      return this.$store.getters.companies.filter(c => !c.archived)
    },
    affiliates (companyId) {
      return this.$store.getters.affiliates.filter(aff => aff.affiliateCompanyId == companyId)
    }
  },
  methods: {
    async addCompany () {
      const res = await this.$store.dispatch('openModal', {name: 'Affiliate Company',
                                         mode: 'Create',
                                         object: new AffiliateCompanyProxy()})
    },
    async editCompany (company) {
      const res = await this.$store.dispatch('openModal', {name: 'Affiliate Company',
                                         mode: 'Edit',
                                         object: new AffiliateCompanyProxy(company)})
    },
    async archiveCompany (company) {
      company.archived = true
      const res = await this.$store.dispatch('updateRestObject', new AffiliateCompanyProxy(company))
      console.log('removeCompany(): res = ', res)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Archived!'})
      }
    }
  }
}
</script>

<style scoped>
.red {
  color:red
}
</style>